import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    "id": undefined, // optional 
    "nguoi_danh_gia": undefined, // required Tên người đánh giá
    "nguoi_danh_gia_id": undefined, // required Mã người đánh giá
    "thoi_diem_danh_gia": undefined, // required Thời điểm phản hồi
    "doi_tuong_danh_gia": undefined, // optional Đối tượng bị đánh giá
    "doi_tuong_danh_gia_id": undefined, // optional Tên đối tượng bị đánh giá
    "danh_gia_id": undefined, // optional Mã đánh giá cha
    "gia_tri": undefined, // optional min: 1, max: 5 Số sao đánh giá của người dùng
    "noi_dung": undefined, // optional Nội dung phản hồi
    "hien_thi": undefined, // optional Cho phép có hiển thị không
    "lock": undefined, // optional Có khóa đánh giá không
    "thong_tin_them": // optional Lưu thông tin thêm của từng đánh giá
    {
        "media": [], // optional Thông tin file đính kèm
    }
}


model.dataFormOther = {
    fileUploadOption: {
        FileDinhKem: {
            limit: null,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },
};

model.validForm = {
    
};

model.listKhoa = [
    {
        value: true,
        label: "Khoá"
    },
    {
        value: false,
        label: "Không khoá"
    }
];

model.listKhoaSearch = [
    {
        value: "true",
        label: "Khoá"
    },
    {
        value: "false",
        label: "Không khoá"
    }
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "hien_thi": "",
            "thoi_diem_danh_gia": "",
            "nguoi_danh_gia_id": "",
            "doi_tuong_danh_gia_id": "",
            "lock": ""
        },
        valid: {
           
        },
        operator: {
            "hien_thi": "", //:regex:, $vn_text=Viêt nam
            "thoi_diem_danh_gia": ":in_that_day:",
            "nguoi_danh_gia_id": "",
            "doi_tuong_danh_gia_id":"",
            "lock": ""
        }
    }
};

export default model;